import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class PlacesCoordinatesService {
  constructor() {}

  buildCoordinatesArrayFromString(MultiGeometryCoordinates: any) {
    const finalData = [];
    let grouped = MultiGeometryCoordinates.split("\n");

    grouped.forEach(function (item, i) {
      let a = item.trim().split(",");

      finalData.push({
        lng: parseFloat(a[0]),
        lat: parseFloat(a[1]),
      });
    });

    return finalData;
  }
}
